import React, { useState } from 'react';
import { Flex, DatePicker, Card, Statistic, Spin, Alert, Typography } from 'antd';
import dayjs from 'dayjs';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import MyText from '../../components/UI/Text/MyText';
import GreenLightButton from '../../components/UI/Buttons/GreenLightButton';
import { clrs } from '../../constants/colors';
import WaterAnalyzerService from '../../services/WaterAnalyzerService';

const { Title } = Typography;

const WaterAnalysisPage = () => {
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleSearch = async () => {
        if (!selectedMonth) return;

        const dateStart = selectedMonth.startOf('month').format('YYYY-MM-DD');
        const dateEnd = selectedMonth.endOf('month').format('YYYY-MM-DD');

        setLoading(true);
        setResult(null);
        setError(null);

        try {
            const data = await WaterAnalyzerService.analyze(dateStart, dateEnd);
            setResult(data);
        } catch (err) {
            const detail = err?.response?.data?.detail;
            setError(detail || 'Не удалось получить данные. Попробуйте другой период.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <Flex
                style={{ width: '100%', padding: '130px 20px 40px 20px', minHeight: '100vh' }}
                vertical
                align="center"
                justify="flex-start"
            >
                <Flex
                    style={{ width: '100%', maxWidth: 1200 }}
                    gap={24}
                    vertical
                    align="stretch"
                    justify="flex-start"
                >
                    <MyText style={{ fontSize: '2rem', fontWeight: 800, color: clrs.textColor }}>
                        Анализ водной поверхности
                    </MyText>

                    <Card
                        style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}
                        bodyStyle={{ padding: '24px' }}
                    >
                        <Flex gap={16} align="center" wrap="wrap">
                            <Flex vertical gap={4}>
                                <MyText style={{ color: clrs.grey, fontSize: '0.9rem' }}>
                                    Выберите год и месяц
                                </MyText>
                                <DatePicker
                                    picker="month"
                                    value={selectedMonth}
                                    onChange={(date) => setSelectedMonth(date)}
                                    style={{ width: 200 }}
                                    placeholder="Месяц и год"
                                    disabledDate={(current) => current && current > dayjs().endOf('month')}
                                />
                            </Flex>
                            <GreenLightButton
                                onClick={handleSearch}
                                loading={loading}
                                disabled={!selectedMonth}
                                style={{ marginTop: 22, fontSize: '1rem', padding: '10px 24px' }}
                            >
                                Анализировать
                            </GreenLightButton>
                        </Flex>
                    </Card>

                    {loading && (
                        <Flex align="center" justify="center" style={{ padding: '60px 0' }}>
                            <Spin size="large" tip="Выполняется анализ, это может занять некоторое время..." />
                        </Flex>
                    )}

                    {error && !loading && (
                        <Alert
                            type="error"
                            message="Ошибка"
                            description={error}
                            showIcon
                            style={{ borderRadius: 8 }}
                        />
                    )}

                    {result && !loading && (
                        <Flex gap={24} vertical>
                            <Card
                                style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}
                                bodyStyle={{ padding: '24px' }}
                            >
                                <Flex gap={40} align="center" wrap="wrap">
                                    <Statistic
                                        title="Площадь воды"
                                        value={result.water_area_km2}
                                        precision={2}
                                        suffix="км²"
                                        valueStyle={{ color: clrs.blue, fontWeight: 700, fontSize: '2rem' }}
                                    />
                                    <Statistic
                                        title="Период анализа"
                                        value={result.period}
                                        valueStyle={{ color: clrs.textColor, fontSize: '1.1rem' }}
                                    />
                                    <Statistic
                                        title="Снимков использовано"
                                        value={result.images_used}
                                        valueStyle={{ color: clrs.textColor, fontSize: '1.1rem' }}
                                    />
                                </Flex>
                            </Card>

                            <Card
                                title={
                                    <Title level={5} style={{ margin: 0, color: clrs.textColor }}>
                                        Карта водной поверхности
                                    </Title>
                                }
                                style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}
                                bodyStyle={{ padding: 0, overflow: 'hidden', borderRadius: '0 0 12px 12px' }}
                            >
                                <iframe
                                    srcDoc={result.html}
                                    width="100%"
                                    height="600px"
                                    frameBorder="0"
                                    title="Карта водной поверхности"
                                    style={{ display: 'block' }}
                                />
                            </Card>
                        </Flex>
                    )}
                </Flex>
            </Flex>
            <Footer />
        </div>
    );
};

export default WaterAnalysisPage;
